import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=328e13eb&scoped=true"
import script from "./menu-item.vue?vue&type=script&lang=js"
export * from "./menu-item.vue?vue&type=script&lang=js"
import style0 from "./menu-item.vue?vue&type=style&index=0&id=328e13eb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328e13eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('328e13eb')) {
      api.createRecord('328e13eb', component.options)
    } else {
      api.reload('328e13eb', component.options)
    }
    module.hot.accept("./menu-item.vue?vue&type=template&id=328e13eb&scoped=true", function () {
      api.rerender('328e13eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/draw-menu/components/menu-item.vue"
export default component.exports